module.exports = __webpack_public_path__ + "static/media/delete.b8a9733f.svg";